module.exports = __webpack_public_path__ + "img/img-fe50df79.f24a72c5.png";